<div class="dialog-container">
  <div class="dialog-header">
    <div class="dialog-header-title">
      {{ 'CUSTOMER_DETAILS.ENTER_USER_DETAILS' | fallbackTranslate }}
    </div>
    <div class="dialog-header-cross" (click)="cancel_clicked()">
      <img [src]="images.CROSS" class="img-20" alt="close" />
    </div>
  </div>

  <div class="dialog-form">
    <div class="confirm-class">
      <div class="order-content-rc" id="new-order-details-id">
        <div class="modal-information">
          <span nz-typography class="fs-14 fw-600">
            {{ 'CUSTOMER_DETAILS.MOB_CUST_SEARCH' | fallbackTranslate }}
          </span>
        </div>
        <div class="mt-10 mr-25 ml-25">
          <!-- User Details -->
          <div>
            <div class="flex-row">
              <form nz-form [formGroup]="customerForm" class="wd-100">
                <div class="form-container">
                  <div
                    nz-row
                    [nzGutter]="8"
                    nzType="flex"
                    nzJustify="space-around"
                    nzAlign="middle"
                  >
                    <nz-form-item
                      nz-col
                      [nzXs]="{ span: 4 }"
                      [nzMd]="{ span: 4 }"
                      [nzLg]="{ span: 4 }"
                      [nzXl]="{ span: 4 }"
                    >
                      <label>
                        {{ 'CUSTOMER_DETAILS.ENTER_DIAL_CODE' | fallbackTranslate }}
                      </label>

                      <nz-form-control>
                        <input
                          type="tel"
                          nz-input
                          nzSize="large"
                          placeholder="{{
                            'CUSTOMER_DETAILS.ENTER_DIAL_CODE' | fallbackTranslate
                          }}"
                          class="input-name-class"
                          name="dial_code"
                          formControlName="dial_code"
                          (input)="checkInput($event, 'dial_code')"
                          minlength="2"
                          maxlength="5"
                          onkeypress="return (event.charCode !== 8 && event.charCode === 0 || (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 43)"
                        />
                      </nz-form-control>
                    </nz-form-item>

                    <nz-form-item
                      nz-col
                      [nzXs]="{ span: 10 }"
                      [nzMd]="{ span: 10 }"
                      [nzLg]="{ span: 10 }"
                      [nzXl]="{ span: 10 }"
                    >
                      <label>
                        {{ 'CUSTOMER_DETAILS.CUSTOMER_MO_NUM' | fallbackTranslate }}
                      </label>
                      <nz-form-control
                        [nzValidateStatus]="
                          customerSearch?.numberValidityStatus
                        "
                        nzHasFeedback
                      >
                        <nz-input-group
                          nzSize="large"
                          [nzPrefix]="prefixTemplateUser"
                        >
                          <input
                            type="tel"
                            nz-input
                            placeholder="{{
                              'CUSTOMER_DETAILS.ENTER_MOBILE_NUMBER' | fallbackTranslate
                            }}"
                            id="number"
                            class="input-name-class"
                            name="number"
                            maxlength="15"
                            (input)="checkInput($event, 'phone')"
                            onkeypress="return (event.charCode !== 8 && event.charCode === 0 || (event.charCode >= 48 && event.charCode <= 57))"
                            formControlName="number"
                          />
                        </nz-input-group>
                        <ng-template #prefixTemplateUser>
                          <i nz-icon nzType="search"></i>
                        </ng-template>
                      </nz-form-control>
                    </nz-form-item>

                    <nz-form-item
                      nz-col
                      [nzXs]="{ span: 10 }"
                      [nzMd]="{ span: 10 }"
                      [nzLg]="{ span: 10 }"
                      [nzXl]="{ span: 10 }"
                    >
                      <label>
                        {{ 'CUSTOMER_DETAILS.CUSTOMER_NAME' | fallbackTranslate }}
                      </label>
                      <nz-form-control
                        [nzValidateStatus]="customerSearch?.nameValidityStatus"
                        nzHasFeedback
                      >
                        <input
                          type="text"
                          nzSize="large"
                          nz-input
                          [placeholder]="customerSearch?.namePlaceHolder"
                          id="name"
                          class="input-name-class"
                          name="name"
                          formControlName="name"
                          (input)="checkInput($event, 'name')"
                          onkeypress="return (event.charCode !== 8 && event.charCode === 0 || ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <=122) || event.charCode === 32))"
                        />
                      </nz-form-control>
                    </nz-form-item>
                  </div>

                  <div
                    class="form-group"
                    class="form-input-container"
                    *ngIf="this.selectedOrder.platform == 'others'"
                  >
                    <div class="form-area">
                      <label>
                        {{
                          'CUSTOMER_DETAILS.ENTER_ORDERING_PLATFORM_NAME'
                            | fallbackTranslate
                        }}
                      </label>
                      <input
                        type="text"
                        nzSize="large"
                        nz-input
                        placeholder="{{
                          'CUSTOMER_DETAILS.ENTER_HERE' | fallbackTranslate
                        }}"
                        id="address"
                        class="input-name-class"
                        name="address"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div *ngIf="!this.doesUserExist" class="user-error">
          * {{ 'POS.USER_NOT_REGISTERED' | fallbackTranslate }}
        </div>
        <div class="spinner-container" *ngIf="this.isLoyaltyLoading">
          <ng-template #indicatorTemplate
            ><i nz-icon nzType="loading"></i
          ></ng-template>
          <nz-spin nzSimple [nzIndicator]="indicatorTemplate"> </nz-spin>
        </div>
        <div class="loyalty__container" *ngIf="this.showLoyaltyCashback">
          <div class="modal-information loyalty-header">
            <span nz-typography class="fs-14 fw-600">
              {{ 'POS.LOYALTY_CASHBACK' | fallbackTranslate }}
            </span>
          </div>
          <div class="loyalty__price-container">
            <div class="loyalty__price-info">
              {{ 'POS.LOYALTY_CASHBACK_AVAILABLE' | fallbackTranslate }}:
              <span class="loyalty__price-value"
                >{{ Currency }} {{ loyaltyCashback?.total_credits_text }}</span
              >
            </div>
          </div>
          <div class="loyalty__checkbox-container">
            <input
              nz-tooltip 
              [nzTooltipTitle]="loyaltyTooltipText"
              type="checkbox"
              class="loyalty__checkbox"
              [checked]="this.applyCashbackChecked"
              (change)="this.handleCashbackCheckbox($event)"
              [disabled]="this.loyaltyCashback.total_credits === 0 || this.disableLoyaltyCheckbox"
            />
            <div class="loyalty__checkbox-label">
              {{ 'POS.LOYALTY_CASHBACK_APPLY' | fallbackTranslate }}
            </div>
          </div>
        </div>
        <div class="loyalty-error" *ngIf="loyaltyErrorCondition">*{{'POS.ADD_ITEMS_WORTH' | fallbackTranslate}} {{Currency}} {{this.data.minLoyaltyRedeem - this.data.itemTotal}} {{'POS.MORE_TO_APPLY' | fallbackTranslate}}</div>
        <div class="dialog-footer">
          <button
            class="save"
            (click)="userDetailsClicked()"
            [disabled]="
              this.isLoyaltyLoading || this.isApiRequestLoading ||
              this.loyaltyCashback.total_credits === 0 ||
              !this.applyCashbackChecked
            "
            nz-button
            [nzLoading]="this.isApiRequestLoading"
          >
            SAVE
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
